import React from "react";

$(".js-calendar-action").on("click", function (e) {
  e.preventDefault();
  let form = $(this).closest("form");
  let parent = $(this).closest("#calendar");
  let method = form.attr("method") || "POST";
  let removeElements = form.attr("data-remove-elements");
  let removeElementsArray =
    removeElements !== undefined ? removeElements.split(",") : [];
  let toggleElements = form.attr("data-toggle-elements");
  let toggleElementsArray =
    toggleElements !== undefined ? toggleElements.split(",") : [];

  window
    .fetch($(this).closest("form").attr("action"), {
      method: method,
      headers: {
        "Content-Type": "application/json",
        // 'credentials': 'same-origin',
        "X-Requested-With": "XMLHttpRequest",
      },
      data: form.serialize(),
    })
    .then((res) => res.json())
    .then(
      (result) => {
        parent.find(".hint").length
          ? parent.find(".hint").html(result.message)
          : "";
        removeElementsArray.forEach((element) => {
          parent.find(element).remove();
        });
        toggleElementsArray.forEach((element) => {
          parent.find(element).toggleClass("hidden");
        });
        parent.find(".hint").length
          ? parent.find(".hint").html(result.message)
          : "";
        if (method === "DELETE") {
          if (result.code === 200) {
            window.location.reload();
          } else {
            alert(result.message);
          }
        }
      },
      (error) => {
        alert(error);
      }
    );
});
